<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="left_nav">
        <div @click="navCall = item.num" :class="item.num===navCall?'navSelected':''"
             v-for="item in NavList"
             :key="item.num">
          {{ item.title }}
        </div>
      </div>
      <div class="form_wrap">
        <div class="toolsIntroduce">
          <div class="left">
            <img src="../img/face.png" alt="">
          </div>
          <div class="right">
            <p>
              功能介绍
            </p>
            <span style="display: block">
             接入全球热门的 AI 视频，Pika 1.5、2.0 专业版为用户提供一系列强大的视频编辑与生成功能。
            </span>
          </div>
        </div>
        <div class="options_item" v-if="navCall===2">
          <div class="item_title item_title_other" flex-align>
            <div class="text">上传参考图<span v-if="create_form.mode == 2.1 || create_form.mode == 2.2">（最多六张）</span></div>
            <div class="title_text_other" @click="removeAllImages" v-if="create_form.mode == 2.1 || create_form.mode == 2.2">移除所有</div>
          </div>
          <!-- 多图上传显示区域 (Pika 2.1/2.2 多图时) -->
          <div class="twoLoadImgBox" v-if="create_form.mode != 1 && ingredientslist.length > 0">
            <div class="loadItem" v-for="(lodimg,imgind) in ingredientslist">
              <div class="ingredientsBoxlist">
                <el-image :src="cdn_url_replace(lodimg)" :preview-src-list="[lodimg]">
                </el-image>
                <div class="yesUpload_delIcon">
                  <i class="el-icon-delete" @click="delLodImg(imgind)"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="Reference_image" v-loading="upImgloading" element-loading-background="rgba(122, 122, 122, 0.8)"
               v-show="(create_form.mode==1)||(create_form.mode!=1&& ingredientslist.length<6)">
            <el-upload :http-request="$projectUpload"
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/aivideo/upload/?soft=1'"
                :show-file-list="false"
                accept=".jpg,.png"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                multiple>
              <div v-if="create_form.img_url" class="yesUpload">
                <img :src="create_form.img_url" alt="" class="yesUpload_img">
                <div class="yesUpload_icon" @click.stop="create_form.img_url=''">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过10MB</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">视频描述</div>
          </div>
          <div class="btm_area_con">
            <div>
                <textarea class="text" rows="4" v-model="create_form.desc"
                          placeholder="输入视频描述词，描述词越详细生成的视频效果更佳~"></textarea>
            </div>
            <div class="depict_switch">
              <div class="switch">
                <el-switch
                    style="zoom: 0.7"
                    @change="getPromptData4()"
                    active-value="1"
                    inactive-value="0"
                    active-color="#5865f2"
                    inactive-color="#53555f"
                    v-model="auto_spell">
                </el-switch>
                <span style="margin-left: 4px;font-size: 12px">一键优化描述词</span>
              </div>
              <div class="empty" @click="create_form.desc">清空</div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">模型选择</div>
          </div>
          <div class="model_list">
            <div class="quality">
              <div @click="mode_style(model)"   v-for="(model,index) in platform_list"
                   :class="create_form.mode==model.id?'quality_btns':'quality_btn'">
                {{ model.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="twoStatBox options_item" v-show="navCall == 2 && (create_form.mode == 2.1 || create_form.mode == 2.2)">
          <div class="item_title" flex-align>
            <div class="text">图片组模式</div>
          </div>
          <div class="twoBtnBox">
              <div :class="btnAct==btn.id?'twoBtnItem btnAct':'twoBtnItem'" v-for="btn in twoBtnlist" :key="btn.id" @click="checkBtn(btn)">{{ btn.name }}</div>
          </div>
        </div>

        <div class="options_item"  v-show="create_form.mode==1">
          <div class="item_title" flex-align>
            <div class="text">风格选择</div>
          </div>
          <div class="style_wrap" >
            <div @click="create_form.style = sty.id"
                 :class="['size_item', { 'active': create_form.style === sty.id }]"
                 v-for="sty in style_list" :style="{ backgroundImage: `url(${sty.img})` }">
              <div class="item_name">{{ sty.name }}</div>
            </div>
          </div>
<!--          <div class="mode_2" v-if="create_form.mode == 1.5">-->
<!--            <div @click="create_form.style = sty.id" class="mode_body"-->
<!--                 :style="create_form.style == sty.id?'border: 2px solid #5865f2;':'border: 2px solid #1e1f22;'"-->
<!--                 v-for="(sty,index) in style_list2" @mouseenter="playVideo(index)" @mouseleave="pauseVideo(index)">-->
<!--              <video ref="videoPlayer" :src="sty.img" v-if="sty.id!=14"></video>-->
<!--              <div :class="sty.id!=14?'item_name':'item_name2'">{{ sty.name }}</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">生成尺寸</div>
          </div>
          <div class="size_wrap">
            <div @click="create_form.aspect_ratio = size.id" flex-center
                 :class="['size_item', { 'active': create_form.aspect_ratio === size.id }]"
                 v-for="size in aspect_list">
              <img class="size_img" :src="size.img" alt="">
              <div class="">{{ size.type }}</div>
            </div>
          </div>
        </div>
        <!-- Pika 2.2 专用参数选择 -->
        <div class="pika22_options" v-if="create_form.mode == 2.2">
          <!-- 画质选择 -->
          <div class="item_title" flex-align>
            <div class="text">画质选择</div>
          </div>

          <div class="quality_wrap">
            <div @click="create_form.is_hd = 0" flex-center
                 :class="['quality_item', { 'active': create_form.is_hd === 0 }]">
              标清
            </div>
            <div @click="create_form.is_hd = 1" flex-center
                 :class="['quality_item', { 'active': create_form.is_hd === 1 }]">
              高清
            </div>
          </div>

          <!-- 时长选择 -->
          <div class="item_title" flex-align>
            <div class="text">时长选择</div>
          </div>
          <div class="duration_wrap">
            <div @click="create_form.seconds = 5" flex-center
                 :class="['duration_item', { 'active': create_form.seconds === 5 }]">
              5秒
            </div>
            <div @click="create_form.seconds = 10" flex-center
                 :class="['duration_item', { 'active': create_form.seconds === 10 }]">
              10秒
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">高级参数</div>
          </div>
          <div class="high_param">
            <div class="param_name" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">每秒帧数</div>
            <div class="param_content" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">
              <div class="param_value" flex-center>{{ create_form.frameRate }}</div>
              <el-slider v-model="create_form.frameRate" :min="8" :max="24" :show-tooltip='false'></el-slider>
            </div>
            <div class="split_line" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle"></div>
            <div class="param_name" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">运动幅度</div>
            <div class="param_content" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">
              <div class="param_value" flex-center>{{ create_form.motion }}</div>
              <el-slider v-model="create_form.motion" :min="0" :max="4" :show-tooltip='false'></el-slider>
            </div>
            <div class="split_line" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle"></div>
            <div class="param_name" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">文案一致性</div>
            <div class="param_content" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">
              <div class="param_value" flex-center>{{ create_form.guidanceScale }}</div>
              <el-slider v-model="create_form.guidanceScale" :min="5" :max="25" :show-tooltip='false'></el-slider>
            </div>
            <div class="split_line" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle"></div>
            <div class="sound_line" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">
              <div class="line_text" v-if="create_form.mode != 2.1 && create_form.mode != 2.2&&isStyle">
                <div class="sound_name">开启音效</div>
                <div class="sound_tips">系统生成的视频声音</div>
              </div>
              <div class="sound_switch">
                <div class="switch_label"><img class="sound_icon" src="./img/music.png" alt=""> 音效</div>
                <el-switch v-model="create_form.sfx" active-color="#ffedd2" inactive-color="#313338"></el-switch>
              </div>
            </div>
            <div class="split_line" v-if="create_form.mode != 2.1 && create_form.mode != 2.2"></div>
            <div class="param_name">负向提示词</div>
            <el-input class="negative_area" :rows="4" v-model="create_form.negativePrompt" type="textarea"
                      placeholder="请输入不想出现的元素"/>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div :class="['primary_button']" @click="sendMsg" v-loading="sending">
        <!-- <template v-if="isVipUser">官方接口维护1~2天</template> -->
        <template>
          提交任务
          <span class="fz12" v-if="create_form.mode != 'Sora'">（消耗{{getScoreConsumption()}}积分）</span>
        </template>
      </div>
    </div>

    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>

  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
import AliCdn from '../../utils/ali_cdn'

export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      btnAct:0,
      twoBtnlist:[
        {
          id:0,
          name:'创意',
          par:'creative'
        },
        {
          id:1,
          name:'精确',
          par:'precise'
        },
      ],
      isStyle:true,
        create_form: {
          create_type: 1,
          img_url: "",
          desc: "",
          style: 1,
          size: '16:9',
          left_or_right: '',
          down_or_up: '',
          focus: '',
          frames: 24,
          amplitude: 2,
          same: 12,
          sfx: false,
          negative_word: '',
          negativePrompt: "",
          aspect_ratio: 0,
          frameRate: 24,
          motion: 0,
          guidanceScale: 15,
          duration: 3,
          soft: 2,
          mode: 2.2,
          ingredients:[],
          platform:null,
          ingredients_mode:"creative",
          is_hd: 0, // 新增：0标清，1高清
          seconds: 5, // 新增：时长选择，5秒或10秒
        },
      ingredientslist:[],
      sending: false,
      navCall: 1,
      NavList: [
        {title: '文生视频', num: 1,},
        {title: '图生视频', num: 2,},
      ],
      fileApi: FILE_API_SERVER,
      frame: false,
      fileAPI: API_SERVER,
      imgDialogVisible: false,
      model_desc: '',
      platform_list: [
        // {type: 1, name: "Pika 1.0", name2: "gen2", id: 1},
        {type: 3, name: "Pika 2.1", name2: "gen3a", id: 2.1}, // 2.1移除风格选择
        {type: 4, name: "Pika 2.2", name2: "gen3a", id: 2.2}, // 2.2有HD/SD和时长选择
      ],

      style_list: [
        // {type: 1, name: "随机盲盒", img: require('./img/random.png'), id: 0},
        {type: 2, name: "日漫风格", img: require('./img/anime.png'), id: 1},
        {type: 3, name: "电影风格", img: require('./img/moody.png'), id: 2},
        {type: 4, name: "3D渲染", img: require('./img/3d.png'), id: 3},
        {type: 5, name: "水彩风格", img: require('./img/watercolor.png'), id: 4},
        {type: 6, name: "自然风格", img: require('./img/natural.png'), id: 5},
        {type: 7, name: "黏土风格", img: require('./img/claymation.png'), id: 6},
        {type: 8, name: "黑白风格", img: require('./img/black-and-white.png'), id: 7},
      ],
      style_list2: [
        // {type: 1, name: "随机盲盒", img: require('./img/random.png'), id: 0},
        {type: 2, name: "漂浮", img: require('./img/levitate.webm'), id: 1},
        {type: 3, name: "斩首", img: require('./img/decapitate.webm'), id: 2},
        {type: 4, name: "目瞪口呆", img: require('./img/eye-pop.webm'), id: 3},
        {type: 5, name: "惊奇", img: require('./img/tada.webm'), id: 4},
        {type: 6, name: "紧缩", img: require('./img/deflate.webm'), id: 5},
        {type: 7, name: "坍塌", img: require('./img/crumble.webm'), id: 6},
        {type: 8, name: "溶解", img: require('./img/dissolve.webm'), id: 7},
        {type: 8, name: "压扁", img: require('./img/squish.webm'), id: 8},
        {type: 8, name: "膨胀", img: require('./img/inflate.webm'), id: 9},
        {type: 8, name: "融化", img: require('./img/melt.webm'), id: 10},
        {type: 8, name: "粉碎", img: require('./img/crush.webm'), id: 11},
        {type: 8, name: "糕切", img: require('./img/cake-ify.webm'), id: 12},
        {type: 8, name: "爆炸", img: require('./img/explode.webm'), id: 13},
        {type: 8, name: "无特殊效果", id: 14},
      ],
      aspect_list: [
        {type: '16:9', img: require('./img/16^9.png'), id: 0},
        {type: '9:16', img: require('./img/9^16.png'), id: 1},
        {type: '1:1', img: require('./img/1^1.png'), id: 2},
        {type: '5:2', img: require('./img/5^2.png'), id: 3},
        {type: '4:5', img: require('./img/4^5.png'), id: 4},
        {type: '3:4', img: require('./img/3^4.png'), id: 5},
      ],
      video_list: [],
      noMore: false,
      loading: false,
      page: 1,
      intervalId: null,

      select_rec_img: {
        img_url: ''
      },
      timer: null,
      max_mj_id: 0,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      success_icon: true,
      perIncan: false, // ai提示词是否返回
      auto_spell: '1', // ai提示词是否关闭
      upImgloading:false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    isVipUser() {
      // 判断是否为已登录的会员用户
      return this.isLogin && this.userInfo && this.userInfo.is_vip >= 1;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    },
    isInputtype() {
      return this.$store.state.isInputtype;
    },
    isInputVal() {
      return this.$store.state.isInputVal;
    },
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
    // 获取用户信息以更新会员状态
    if (this.isLogin) {
      this.getProfile()
    }
  },
  mounted() {

  },

  methods: {
    cdn_url_replace(url, o_url, c_url){
      if (!c_url){
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url){
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, this.cdnOptions)
      }
      return url.replace(o_url, c_url)
    },
    delLodImg(data){
      this.create_form.ingredients.splice(data,1)
      this.ingredientslist.splice(data,1)
    },
    removeUpImg(){
      this.create_form.ingredients = []
      this.ingredientslist = []
    },
    checkBtn(data){
      this.btnAct = data.id
      this.create_form.ingredients_mode = data.par
    },
    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    //发送消息
    sendMsg() {      
      // 先检查登录状态
      if (!this.checkLogin()) {
        return false
      }
      if(!utils.setOptData(this.userInfo,'btn_pika_create')){
          return
      }
      // 会员用户提示维护信息
      if (this.userInfo.is_vip >= 1) {
        this.$message.warning('官方接口维护中，预计1~2天恢复，请稍后再试')
        return false
      }
      // 非会员用户提示开通会员
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      this.create_form.name = this.create_form.desc
      this.create_form.text_prompt = this.create_form.desc
      if (this.create_form.text_prompt === "") {
        this.$message.warning('请输入文字信息')
        return
      }
      if(this.create_form.text_prompt.length>300){
          this.$message.warning('描述信息不能超过300字符')
          return
      }
      if (this.navCall === 1) {
        this.create_form.img_url = ""
        this.create_form.ingredients = []
      }else {
        // if (this.create_form.img_url == '') {
        //   this.$message.warning('请上传图片')
        //   return;
        // }
        if(this.create_form.mode==1){
          console.log('modo1')

          if(this.create_form.img_url == ""){
            this.$message.warning('请上传图片')
            return;
          }
        }else{
          console.log('modo2.1 2.2')
          if(this.ingredientslist.length==0){
            this.$message.warning('请上传图片')
            return;
          }else if(this.ingredientslist.length==1){
            this.create_form.ingredients = []
            this.create_form.img_url = this.ingredientslist[0]
          }else{
            this.create_form.img_url = ""
            this.create_form.ingredients = this.ingredientslist
          }
        }
      }


      if (this.create_form.mode == 'Sora') {
        this.$message.warning('敬请期待')
        return;
      }


      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (this.auto_spell > 0) {
        console.log('ai提示词')
        if (!this.perIncan) {
          this.$store.commit('setisInputVal', this.create_form.desc)
          this.$store.commit('setisInputtype', 'Stable Diffusion')
          this.$store.commit('setisInputValshow', true)
          return;
        }
      }
      // if (this.sendLoading) {
      //   this.$message.warning('正在提交任务！')
      //   return
      // }
      this.create_form.name = this.create_form.desc
      this.create_form.text_prompt = this.create_form.desc
      // this.sendLoading = true
      this.submitQuestion(this.create_form);

    },
    submitQuestion(data, parent_msg_code, i) {
      console.log('提交1',data)
      this.perIncan = false
      // return
      this.sending = true;

      // 提交问题
      // data.source = "pc";
      this.$http.post('/front/aivideo/', data).then((res) => {

        if (res.status == 200) {
          this.getProfile()
          this.inputVal = "";
          // this.checkIds.push(res.data.draw.draw_id)
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          // this.fetchMsg();
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "expired_gift_score") {
            // 队列已满
            this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          }else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    mode_style(item) {
      this.create_form.style = 1
      // 2.1不显示风格选择，支持动态单图/多图上传
      // 2.2显示独立的画质和时长选择，不显示风格选择，支持动态单图/多图上传
      if(item.id == 2.2) {
        this.isStyle = 0  // 2.2不显示风格选择
        this.create_form.platform = 2
        this.removeAllImages()  // 清空所有图片数据
        this.create_form.mode = `${(item.id.toFixed(1))}`
      } else if(item.id == 2.1) {
        this.isStyle = 0  // 2.1不显示风格选择
        this.create_form.platform = 2
        this.removeAllImages()  // 清空所有图片数据
        this.create_form.mode = `${(item.id.toFixed(1))}`
      } else if(item.id == 1) {
        this.isStyle = 1  // Pika 1.0显示风格选择，只支持单图
        this.create_form.platform = null
        this.create_form.mode = item.id
        this.removeAllImages()  // 清空所有图片数据
      } else if(item.id == 1.5) {
        this.isStyle = 1  // 1.5显示风格选择（使用style_list2）
        this.create_form.platform = 2
        this.create_form.mode = item.id
        this.removeAllImages()  // 清空所有图片数据
      } else {
        this.isStyle = 1  // 其他版本显示风格选择
        this.create_form.platform = null
        this.create_form.mode = item.id
        this.removeAllImages()  // 清空所有图片数据
        this.removeUpImg()  // 清空多图
      }
    },
    removeAllImages(){
      // 移除所有图片（单图和多图）
      this.create_form.img_url = ''
      this.create_form.ingredients = []
      this.ingredientslist = []
    },
    getScoreConsumption() {
      // Pika 2.1积分计算
      if(this.create_form.mode == 2.1) {
        // 判断是否为多图：ingredients数组长度大于1
        const isMultiImage = this.ingredientslist.length > 1
        if(isMultiImage) {
          return 100;
        }
        // 单图或无图
        return 50;
      }

      // Pika 2.2积分计算
      if(this.create_form.mode == 2.2) {
        let baseScore = 0;
        // 根据画质设置基础分数
        if(this.create_form.is_hd === 1) {
          // 1080p高清
          baseScore = 30;
        } else {
          // 720p标清
          baseScore = 15;
        }

        // 判断是否为多图：ingredients数组长度大于1，或者既有img_url又有ingredients
        const isMultiImage = this.ingredientslist.length > 1

        if(isMultiImage) {
          baseScore = baseScore * 2; // 30积分变60积分，15积分变30积分
        }

        // 如果选择10秒时长，积分再乘以2
        if(this.create_form.seconds === 10) {
          baseScore = baseScore * 2;
        }

        return baseScore;
      }

      // Pika 1.5特效版本
      if(this.create_form.mode == 1.5) {
        return 31;
      }

      // 其他版本根据isStyle判断：有风格选择20积分，无风格选择70积分
      return this.isStyle ? 20 : 70;
    },
    //视频循环
    playVideo(index) {
      this.$refs.videoPlayer[index].play()
    },
    pauseVideo(index) {
      this.$refs.videoPlayer[index].pause()
    },
    // 上传图片
    handleAvatarSuccess(res) {
      this.upImgloading = false
      if(res.data.error !== ''){
        this.$message.error(res.data.error)
      }
      if (res.status == '200') {
        // 添加新图片到多图数组
        if(this.create_form.mode == 1) {
          console.log('上传单图')
          this.create_form.img_url = res.data.file_full_url
        } else if(this.ingredientslist.length < 6) {
          this.ingredientslist.push( res.data.file_full_url)
        }
      }
    },
    beforeAvatarUpload(file) {
      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message({
          message: '仅支持JPG、PNG格式图片',
          type: 'warning'
        })
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片',
          type: 'warning'
        })
        return
      }
      this.upImgloading = true
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
  },
  watch: {
    '$store.state.isInputValshow'(newVal) {
      console.log('isInputValshow 变化:', newVal);
      if (!newVal) {
        if (this.isInputtype.length > 0) {
          this.perIncan = true
          this.create_form.desc = this.isInputVal
          this.sendMsg()
        }
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;
    .left_nav {
      margin: 10px 20px;
      padding: 4px 0;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #36373d;
      display: flex;
      align-items: center;
      color: #fff;
      background-color: #313338;

      div {
        flex: 1;
        text-align: center;
        margin: 0 4px;
        cursor: pointer;
      }

      .navSelected {
        background-color: #5865f2;
        border-radius: 4px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 60px;
      height: 100%;
      .toolsIntroduce {
        background-color: #1e1f22;
        padding: 16px 14px;
        display: flex;
        border-radius: 5px;
        box-sizing: border-box;
        overflow: hidden;

        .left {
          width: 20px;
          margin-right: 12px;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .right {
          width: calc(100% - 32px);
          flex-grow: 1;
          word-wrap: break-word;

          p {
            font-size: 14px;
            font-weight: 700;
            height: 20px;
            margin-bottom: 5px;
          }

          span {
            font-size: 12px;
            word-wrap: break-word;
            white-space: normal;
          }

        }
      }

      // 绘画描述
      .btm_area_con {
        //position: relative;
        border-radius: 5px;
        border: 2px solid #5865f2;
        padding: 10px 10px;

        .text {
          width: 100%;
          background-color: #2b2d31;
          border: 0;
          color: #b4b9bf;
          font-size: 14px;
          letter-spacing: 1.5px;
          line-height: 20px;
        }

        .depict_switch {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          margin-top: 10px;

          .switch {
            display: flex;
            align-items: center;

            span {
              margin-left: 10px;
            }
          }

          .empty {
            color: #b4b9bf;
            cursor: pointer;
          }

          .empty:hover {
            color: #fff;
          }
        }
      }
      // 模型选择
      .model_list {
        display: flex;


        .model_item {
          border-radius: 6px;
          border: 2px solid #1d2027;
          position: relative;
          overflow: hidden;

          &.active {
            border-color: #5865f2;
          }

          img {
            border: none;
            width: 100%;
          }

          .model_title {
            position: absolute;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.73);
            height: 25px;
            font-size: 12px;
            left: 0;
            bottom: 0;
          }
        }

        .quality {
          display: flex;
          color: #fff;
          font-size: 14px;

          .quality_btn {
            border: 2px solid #393c43;
            border-radius: 3px;
            background-color: #1d2027;
            padding: 10px 24px;
            margin: 0 20px 0 0;
            cursor: pointer;
          }
          .quality_btn:last-child{
            margin: 0;
          }

          .quality_btns {
            border: 2px solid #5865f2;
            border-radius: 3px;
            background-color: #303245;
            padding: 10px 24px;
            margin: 0 20px 0 0;
            cursor: pointer;
          }
          .quality_btns:last-child{
            margin: 0;
          }

        }

      }

      .style_wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;

        .size_item {
          width: 100px;
          height: 100px;
          border-radius: 6px;
          color: #fff;
          flex-direction: column;
          font-size: 12px;
          background-color: #1e1f22;
          border: 2px solid #1e1f22;
          cursor: pointer;
          position: relative;
          //background-image: url("");
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .item_name {
            margin-bottom: 5px;
            background-color: #191315;
            padding: 2px 10px;
            border-radius: 15px;
          }

          &.active {
            border-color: #5865F2;
          }

        }
      }

      .mode_2 {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;

        .mode_body {
          width: 100px;
          height: 100px;
          border-radius: 6px;
          color: #fff;
          font-size: 12px;
          background-color: #1e1f22;

          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: center;
          box-sizing: border-box;

          video {
            width: 80px;
            margin: 0 auto;
            border-radius: 3px;
          }

          .item_name {
            margin: 5px 0 0 7px;
            font-size: 12px;
            color: #949ba4;
          }

          .item_name2 {
            text-align: center;
            font-size: 12px;
            color: #949ba4;
          }
        }


      }
      .size_wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .size_item {
          width: 100px;
          height: 100px;
          flex-direction: column;
          background-color: #1e1f22;
          cursor: pointer;
          border: 2px solid #1e1f22;

          .size_img {
            width: 36px;
            height: 40px;
            display: block;
            border: none;
          }

          &.active {
            border-color: #5865f2;
          }
        }
      }
      .high_param {
        padding: 16px;
        color: #fff;
        background-color: #1f2023;
        border-radius: 8px;
        border: 2px solid #232327;

        .param_name {
          margin-bottom: 10px;
          line-height: 1;
        }

        .param_content {
          display: flex;
          align-items: center;

          .param_value {
            border-radius: 6px;
            height: 32px;
            width: 60px;
            margin-right: 15px;
            background-color: #2d313b;
          }

          .el-slider {
            height: 24px;
            width: 100%;
            display: flex;
            align-items: center;
          }
        }

        .split_line {
          height: 1px;
          margin: 12px 0;
          background-color: #282b31;
          width: 100%;
        }

        .sound_line {
          display: flex;

          .line_text {
            overflow: hidden;
            line-height: 1;
            flex: 1 1 0%;

            .sound_name {
              margin-bottom: 4px;
            }

            .sound_tips {
              color: #cbcbcb;
            }
          }

          .sound_switch {
            display: flex;
            align-items: center;

            .switch_label {
              margin-right: 5px;

              .sound_icon {
                width: 14px;
              }
            }
          }
        }

        .negative_area {
          border-radius: 6px;
          padding: 5px;
          border: 2px solid #393c43;

          :deep(.el-textarea__inner) {
            padding: 0;
            background: transparent;
            border: none;
            box-shadow: none;
            resize: none;
            color: rgba(255, 255, 255, .78);
          }
        }
      }
      .twoLoadImgBox{
        width: 100%;
        //max-height: 260px;
        border-radius: 8px;
        background:#1e1f22;
        overflow: hidden;
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        padding: 10px 10px;
        .loadItem{
          //height: 32px;
          display: flex;
          border-radius: 5px;
          .ingredientsBoxlist{
            position: relative;

            .yesUpload_delIcon{
              position: absolute;
              bottom: -5px;
              right: 0px;
              color: #ffffff;
              cursor: pointer;

            }
            .el-image {
              width: 60px;
              height: 60px;
              border-radius: 5px;
            }
          }
        }
      }

      // 上传参考图
      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;
        box-sizing: border-box;

        .upload-demo {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }


        }
      }

    }
    .twoStatBox{
      .twoBtnBox{
        display: flex;
        justify-content: space-between;
        .twoBtnItem{
          width: 140px;
          height: 40px;
          background-color: #1e1f22;
          color: #fff;
          // font-size: ;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: 2px solid #1e1f22;
          border-radius: 3px;
        }
        .btnAct{
          border: 2px solid #5865f2;
          background-color: #303245;
        }
      }
    }

    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }
      .item_title_other{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }
      }
    }



  }

//提交按钮
  .bottom_area {
    padding-top: 10px;
    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;
      
      &.disabled {
        background-color: #666 !important;
        cursor: not-allowed;
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }


}
// Pika 2.2 专用样式
.pika22_options {
  margin-bottom: 15px;
  .item_title {
    margin-bottom: 10px;

    .text {
      position: relative;
      padding-left: 10px;
      white-space: normal;

      &:before {
        content: "";
        width: 4px;
        height: 15px;
        background: #5865f2;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 4px;
      }

      .icon {
        font-size: 15px;
        margin: 0 0 -2px 10px;
        color: #4a4c52;
        font-weight: bold;
      }
    }
  }

  .quality_wrap, .duration_wrap {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
  }

  .quality_item, .duration_item {
    flex: 1;
    height: 40px;
    background-color: #313338;
    border: 1px solid #42464e;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    color: #b5bac1;
    transition: all 0.2s ease;

    &:hover {
      background-color: #404249;
      border-color: #5865f2;
    }

    &.active {
      background-color: #5865f2;
      border-color: #5865f2;
      color: #fff;
    }
  }
}




/deep/ .el-loading-mask {
  background: none;
}
</style>